import React, { useState, useEffect, useMemo, useRef } from "react";
import { formatDecimal, formatMoney, formatDateTime, formatText, formatDate } from "../../utils/formatters";
import { generateInvoicesPDF } from "../../utils/pdf/InvoicesPDF/generateInvoicesPDF";
import { Tabs, Tab, Box } from "@mui/material";
import InvoiceDetailView from "./InvoiceDetailView";

function ModalPreinvoices({ isOpen, onClose, message }) {
  const [viewMode, setViewMode] = useState("detalle");
  const [pdfUrl, setPdfUrl] = useState(null);
  const [loadingPdf, setLoadingPdf] = useState(false);
  const [tab, setTab] = useState("FC");
  const [tabDv, setTabDv] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setViewMode("detalle");
      setPdfUrl(null);
    }
  }, [isOpen]);

  const handleViewPDF = async () => {
    try {
      setLoadingPdf(true);

      let url;
      url = await generateInvoicesPDF(message.id, "view");
      setPdfUrl(url);
      setViewMode("pdf");

    } catch (err) {
      console.error(err);
    } finally {
      setLoadingPdf(false);
    }
  };

  if (!isOpen) return null;
  // (2026-05-15) Documentos vinculados = NC/ND + (si es factura de comisión
  // de tercero) la factura de origen a la que corresponde.
  const docsVinculados = [
    ...(message?.factura_origen
      ? [{ ...message.factura_origen, _esOrigen: true }]
      : []),
    ...((message?.documentos_vinculados) || []),
  ];
  const hasNotaDebitoItems =
    message?.tipo_documento === "ND" &&
    message?.nota_debito_detalle?.items?.length > 0 && !message?.nota_debito_detalle?.items[0].producto;
  //console.log('hasNotaDebitoItems: ', hasNotaDebitoItems);
  var itemsList;
  if (message.tipo_documento == 'ND' && message.nota_debito_detalle?.items?.length > 0){
    itemsList = message.nota_debito_detalle?.items;
  }else if (message.tipo_documento == 'NC' && message.nota_credito_detalle?.items?.length > 0){
    itemsList = message.nota_credito_detalle?.items;
  }else{
    itemsList = message.items;
  }
  //console.log('message: ', message);
  return (
    <div className="fixed inset-0 z-50 flex justify-center items-center bg-black/50 p-4 overflow-y-auto">
      <div className="bg-white rounded-2xl shadow-sirius-lg w-full max-w-[1200px] max-h-[90vh] overflow-y-auto relative p-6">
        {/* Header */}
        <div className="text-center mb-0">
          <div className="flex justify-between items-center mb-4">
            <h6 className="text-lg md:text-xl font-display font-bold text-ink-900">
              Detalles de la {(message.tipo_documento == 'FC' ? 'Factura' : (message.tipo_documento == 'ND' ? 'Nota de Débito' : 'Nota de Crédito') )}
            </h6>
            <div className="flex gap-2">
              <button
                className="px-4 py-1.5 bg-twilight-indigo-600 hover:bg-twilight-indigo-500 text-white text-sm font-semibold rounded-lg transition"
                onClick={handleViewPDF}
              >
                Ver PDF
              </button>
              {viewMode === "pdf" && (
                <button
                  className="px-4 py-1.5 bg-slate-200 hover:bg-slate-300 text-ink-700 text-sm font-semibold rounded-lg transition"
                  onClick={() => setViewMode("detalle")}
                >
                  Volver
                </button>
              )}
            </div>
          </div>
          {message.tipo_documento == 'FC' && viewMode === "detalle" && (
            <div className="w-full lg:w-12/12 m-0 p-0 text-center">
              <hr className="my-0 border-b-1 border-blueGray-300"/>
              <Tabs value={tab} textColor="primary" indicatorColor="primary" centered onChange={(e, v) => {
                setTab(v);
                if (tabDv == false){
                  if (v == 'DV' && docsVinculados.length > 0){
                    setTabDv(docsVinculados[0].id);
                  }
                }
              }}>
                <Tab value="FC" label="Factura" />
                <Tab value="DV" label="Documentos vinculados" />
              </Tabs>
            </div>
          )}
          <hr className="my-4 border-b border-blueGray-300"/>
        </div>
        {tab === "FC" && viewMode === "detalle" && (
          <InvoiceDetailView message={message} />
        )}
        {tab === "DV" && viewMode === "detalle" && (
          docsVinculados.length > 0 ? (
            <>
              <div className="w-full lg:w-12/12 mb-3 p-0 text-center">
                <Tabs className="mb-3" value={tabDv} onChange={(e, v) => setTabDv(v)} centered>
                  {docsVinculados.map(item => (
                    <Tab
                      key={item.id}
                      value={item.id}
                      label={
                        item._esOrigen
                          ? `FACTURA DE ORIGEN - ${item.numero_control}`
                          : `${item.tipo_documento === 'NC' ? 'NOTA DE CREDITO' : 'NOTA DE DEBITO'} - ${item.numero_control}`
                      }
                    />
                  ))}
                </Tabs>
              </div>

              {/* 🔥 Aquí reutilizas el mismo componente */}
              {tabDv && (
                <InvoiceDetailView
                  message={
                    docsVinculados.find(doc => doc.id === tabDv)
                  }
                />
              )}
            </>
          ) : (
            <div className="text-center py-2">
              No presenta documentos vinculados
            </div>
          )
        )}

        {viewMode === "pdf" && (
          <div className="w-full h-[80vh]">
            {loadingPdf ? (
              <div className="text-center mt-10">Generando PDF...</div>
            ) : (
              <iframe
                src={`${pdfUrl}#toolbar=0`} //src={pdfUrl}
                width="100%"
                height="100%"
                style={{ border: "none" }}
                title="PDF Viewer"
              />
            )}
          </div>
        )}
        {/* Botón Cancelar */}
        <div className="flex justify-center mt-6">
          <button
            className="px-6 py-2 bg-twilight-indigo-600 hover:bg-twilight-indigo-500 text-white font-semibold rounded-xl transition"
            onClick={onClose}
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}

export default ModalPreinvoices;
